module.exports = function () {
    var scroll = window.requestAnimationFrame ||

        window.webkitRequestAnimationFrame ||

        window.mozRequestAnimationFrame ||

        window.msRequestAnimationFrame ||

        window.oRequestAnimationFrame ||

        function (callback) {

            window.setCurrentStateTimeout(callback, 1000 / 600);

        };

    function init_scroll() {

        // Range that the cycle words will fade out. A larger number will make the user scroll more and will fade out more gradually.
        var cycleWordsFadeRange = 200;
        var blocksFadeRange = 600;

        if (!ICF.Utils.DeviceDetection.IsMobile()) {

            var windowHeight = jQuery(window).height();

            var fadeStart = 0,

                fadeUntil = cycleWordsFadeRange,

                $fading = jQuery('.parallax-banner').find('.parallax-bg');


            var offset = jQuery(document).scrollTop(),

                opacity = 0;

            if (offset <= fadeStart) {

                opacity = 1;

            } else if (offset <= fadeUntil) {

                opacity = 1 - offset / fadeUntil;

            }

            $fading.css('opacity', opacity);

            if (offset >= cycleWordsFadeRange + 20 && offset <= cycleWordsFadeRange + blocksFadeRange) {

                jQuery('.hero-pod').addClass('showed');

            } else {

                jQuery('.hero-pod').removeClass('showed');
            }

        } else {

            jQuery('.hero-pod').addClass('showed');

        }

    }

    if (!ICF.Utils.DeviceDetection.IsMobile()) {

        var podLeft = jQuery('.hero-pod-left'),

            podRight = jQuery('.hero-pod-right'),

            podHeight = 0,

            throttleTimeout = 500,

            $window = jQuery(window);

        jQuery(window).bind('scroll', function () {

            scroll(init_scroll);

        });

        $window.on('resize', ICF.Utils.Throttle(throttleTimeout, function () {

            podHeight = podLeft.outerHeight() - podRight.outerHeight();

            podRight.css('margin-top', podHeight);

        }))

        setTimeout(function () {
            $window.trigger('resize')
        }, 250);

    } else {

        jQuery('.hero-pod').addClass('showed');

    }
};